import React from "react";
import { Typography, Box } from "@mui/material";

const PriceDisplay = ({ price }) => {
  return (
    <Box sx={{ my: 2 }}>
      <Typography variant="h5" fontWeight="bold">
        {`$${price.toFixed(2)} CAD`}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Final price based on selected options
      </Typography>
    </Box>
  );
};

export default PriceDisplay;
